<div class="body">

    <table mat-table [dataSource]="(providerService.visibleIssues$|async)|sortedObjectArray:active:direction:(providerService.visibleIssues$|async)?.length" class="table" [matSortActive]="active" [matSortDirection]="direction" matSort (matSortChange)="sortData($event)">

        <ng-container matColumnDef="issuenumber">
            <th mat-header-cell mat-sort-header="issuenumber" *matHeaderCellDef>Nummer</th>
            <td mat-cell *matCellDef="let element">

                {{element.value.issuenumber}}

            </td>
            <td mat-footer-cell *matFooterCellDef [attr.colspan]="6" class="footer">
                {{(providerService.visibleIssues$|async)?.length}} von {{(providerService.issues$|async)?.length}} gesamt (Vorgänge/Tickets/Changes/Projekte) ( {{providerService.issueCount$|async}} / {{providerService.incidentCount$|async}} / {{providerService.changeCount$|async}} / {{providerService.projectCount$|async}} )
            </td>
        </ng-container>

        <ng-container matColumnDef="issuetype">
            <th mat-header-cell mat-sort-header="issuetype" *matHeaderCellDef>Typ</th>
            <td mat-cell *matCellDef="let element">

                {{element.value.issuetype|issueTypeName}}

            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="issuetitle">
            <th mat-header-cell mat-sort-header="issuetitle" *matHeaderCellDef>Vorgangsbezeichnung</th>
            <td mat-cell *matCellDef="let element">

                {{element.value.issuetitle}}

            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        
        <ng-container matColumnDef="issuestate">
            <th mat-header-cell mat-sort-header="issuestate" *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let element" [style.color]="element.value.issuestate|issueStatusColor|async">

                {{element.value.issuestate|issueStatus|async}}

            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="controls">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" class="control-cell">

                <button mat-icon-button (click)="showIssue(element.value)">
                    <mat-icon>search</mat-icon>
                </button>

            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: columns;" class="body-row"></tr>
        <tr mat-footer-row *matFooterRowDef="footerColumns; sticky: true"></tr>

    </table>

</div>
